// extracted by mini-css-extract-plugin
export default {"main":"GuestHistory_main__Yerl0"};